<template>
	<div class="wrapperBlock">
		<row align-items="flex-start" justify-content="space-between">
			<span class="wrapperBlock_title">Safety</span>
			<field
					margin="0"
					padding="0"
					height="24"
					label-switch="Report"
					:switch-value="switcherReport"
					@updateSwitch="onCheckbox($event, 'switcherReport')"
					is-dense
					is-switch
					is-off-style
			></field>
		</row>
		<p class="subtext">List of filtered rows with status - not payed yet and added to statement</p>
		<div class="wrapperBlock_body mr-20">
			<main-table
					padding="0 0 10px"
					:flag="flag"
					:headers="getActiveHeaders"
					:listItems="invoiceDrivers"
					@updateClickButton="onClickButton($event, flag)"
					@updateHandleTable="onHandleTable($event, flag)"
					:is-hide-header="false"
					:items-per-page-amount="10"
					:pages="[ 10, 20, 50, 100, 200, 500, 'All' ]"
			></main-table>
		</div>
		<p class="subtext">List of filtered rows with status - not payed yet</p>
		<div class="wrapperBlock_body">
			<main-table
					padding="0 0 10px"
					:flag="flag"
					:headers="getHeaders"
					:listItems="safety"
					@updateClickButton="onClickButton($event, flag)"
					@updateHandleTable="onHandleTable($event, flag)"
					:is-hide-header="false"
					:items-per-page-amount="10"
					:pages="[ 10, 20, 50, 100, 200, 500, 'All' ]"
			></main-table>
		</div>
	</div>
</template>

<script>
import { safetyHeader, safetyActiveHeader } from "@/components/Accounting/CustomerInvoices/CustomerInvoicesCreate/defaultHeaders";

export default {
	name: "BlockSafety",
	props: {
		safety: Array,
		flag: String,
		switcherReport: Boolean,
		invoiceDrivers: Array
	},
	computed: {
		getActiveHeaders() {
			return safetyActiveHeader;
		},
		getHeaders() {
			return safetyHeader;
		}
	},
	methods: {
		onClickButton({ key, item }, nameComponent) {
			this.$emit('updateEditInvoice', { key, item, nameComponent });
		},
		onHandleTable(key, nameComponent) {
			this.$emit('updateEditInvoice', { key, nameComponent });
		},
		onCheckbox({ value }, key) {
			this.$emit('updateCheckbox', { value, key });
		}
	}
};
</script>
<style scoped lang="scss">
@import "../blockStyles";
</style>
